export default "__VITE_ASSET__1UggCbkM__"